export default {
  LOGIN: 'login',
  LOGIN_EXERCISE: 'login-exercise',
}